export default "__VITE_ASSET__DFkdjM8N__"